import React, { useRef, useCallback, useState, useEffect } from 'react';
// import { connect } from 'react-redux'
import Text from './Text';
import Button from './Button';
import Image from './Image';
import ComponentDropArea, { renderComponentDropArea, RenderComponentDropArea } from '../ComponentDropArea';
import DnDOverContent from '../common/DnDOverContent'
import { allowed_types_component_menu, allowed_types_component, allowed_types_component_with_indepth } from './DropContext';
import classNames from 'classnames'

import './ContextMenu_common.css'
import './NormalComponent.css'

// Module actions
// import { setUpdateTargetComponent } from 'store/modules/MessageModule'
// import { updateComponent } from 'store/modules/MessageModule'
// import { setIsDragging } from 'store/modules/DnD'
import DraggableComponent from './DraggableComponent'
import DnDContext from '../DnDContext'
import { DnD_element_type, DnD_element_type_category } from '../common/ConstantValues'
// import { updateComponentIndexPos, updateDepthCompIndexPos } from '../store/modules/MessageModule'
import { onDropComponent } from './DropComponentCommonFunctions'
import Group from './Group';
import { DragHandle } from '../common/Common_styles';
// import { setMsgChanges } from '../store/modules/ResponseGenerationModule';

// import { RenderComponentDropArea0 } from './ComponentDropArea0'

// Last saved rendered height
// let last_saved_component_height = null

/**
 * 이 컴포넌트는 노말 컴포넌트들의 공통된 로직을 중복하지 않기 위해서 생성됨
 * props의 children은 type이 normal인 컴포넌트가 들어올 수 있음
 */
const NormalComponentContainer = (props) => {
  // Custom props
  // renderType: [null||undefined, 'grid']
  const { 
    attr, 
    onDrop, 
    local_id, 
    message_index, 
    row_index, 
    editing_row_index, 
    component_index,
    inDepth,
    isDragging, 
    index, 
    editing_slide_page_index, 
    renderType, 
    noDrag, 
    noDropArea, 
    disable,
    messageActions,
  } = props
  const { 
    name, 
    value, 
    resource, 
    col, 
    fillRemainCol, 
    components, 
    horizontalDropArea, 
    preDropArea,
  } = props

  const { 
    setIsDragging,
    updateComponentIndexPos,
    updateDepthCompIndexPos,
    setMsgChanges,
    updateComponent,

  } = messageActions ? messageActions : {}

  // const [ renderedHeight, setRenderedHeight ] = useState(null)
  const [ renderedHeight, setRenderedHeight ] = useState(null)

  // Ref (inDepth component)
  const depthComponentRef = useCallback((node) => {
    if (node) {
      setRenderedHeight(node.offsetHeight)
    }
  }, [value, name, resource])
  // // Ref (normal component)
  // const normalComponentRef = useCallback((node) => {
  //   if (node) {
  //     setRenderedHeight(node.offsetHeight)
  //   }
  // }, [value, name])

  // console.log("NormalComponentContainer Rendering")
  // const componentRef = useRef()

  // console.log('componentRef :', componentRef);
  // if (componentRef && componentRef.current) {
  //   last_saved_component_height = componentRef.current.offsetHeight
  //   console.log('last_saved_component_height :', last_saved_component_height);
  // }

  /**
   * 메뉴의 컴포넌트 onDrop
   * @param {Object} e 
   */
  const onDrop_component = (e) => {
    const { preDropArea } = e
    console.log('onDrop from NormalComponent  :', e);
    // Disable setMsgChanges when in DepthComponent(Group)
    if (!editing_row_index) { // No inspect index 0 case because, index 0 case(first drop area) is parent component responsibility
      setMsgChanges(true) // Set message changes to true
    }
    e = {
      ...e,
      component_index : preDropArea ? component_index - 1 : component_index,
      editing_row_index : editing_row_index
    }
    onDrop(e)
  }

  /**
   * 랜더링 된 메시지의 컴포넌트 onDrop (Change position)
   * @param {Object} e 
   */
  const onDrop_dragging_component = (e) => {
    console.log('onDrop from NormalComponent - dragging :', e);
    // Disable setMsgChanges when in DepthComponent(Group)
    if (!editing_row_index) { // No inspect index 0 case because, index 0 case(first drop area) is parent component responsibility
      setMsgChanges(true) // Set message changes to true
    }
    const { rowIndexDetail, type, prefix_type, preDropArea } = e
    console.log('preDropArea :', preDropArea);
    e = {...e,
      editing_row_index: editing_row_index,
      rowIndex: rowIndexDetail || rowIndexDetail === 0 ? rowIndexDetail : e.rowIndex,
      slide_page_index: editing_slide_page_index,
    }
    // Logic for depth components
    if (type === DnD_element_type.COMPONENT.NORMAL.GROUP && prefix_type === "NORMAL") {
      onDropComponent(updateDepthCompIndexPos, e, message_index, row_index, preDropArea ? component_index-1 : component_index)
      return
    }
    onDropComponent(updateComponentIndexPos, e, message_index, row_index, preDropArea ? component_index-1 : component_index)
  }

  const onShow_menu = (component) => {
    // const { setUpdateTargetComponent } = props
  }

  const onHide_menu = () => {
    // const { setUpdateTargetComponent } = props
  }

  /**
   * 컴포넌트 업데이트
   * @param {Object} component 
   */
  const _updateComponent = (component) => {
    // Disable setMsgChanges when in DepthComponent(Group)
    if (!editing_row_index) { // No inspect index 0 case because, index 0 case(first drop area) is parent component responsibility
      setMsgChanges(true) // Set message changes to true
    }
    updateComponent({
      updateInfo: component,
      indexInfo: {
        messageIndex: message_index,
        rowIndex: row_index,
        componentIndex: component_index,
        rowIndexDetail: editing_row_index,
        slidePageIndex: editing_slide_page_index,
      }
    })
  }

  /**
   * 컴포넌트 드래그 시작
   */
  const onDraggedStart = () => {
    setIsDragging({
      dragging: true,
      type: null,
    })
  }
  /**
   * 컴포넌트 드래그 종료
   */
  const onDraggedEnd = () => {
    setIsDragging({
      dragging: false,
      type: null,
    })
  }

  /**
   * 컴포넌트 Change position, add component 분기 로직
   * @param {Object} e 
   */
  const onDrop_component_wrapper = (e) => {
    const { cat_type } = e
    if (cat_type === DnD_element_type_category.REN_ELEM) {
      onDrop_dragging_component(e)
    } else if (cat_type === DnD_element_type_category.MENU) {
      onDrop_component(e)
    } else {
      console.error('Drop 된 요소의 cat_type은 유효하지 않음 cat_type -> ', cat_type)
    }
  }
  
  const dropAreaContent = (() => {
    if (isDragging) {
      return (
        <RenderComponentDropArea 
          key={component_index+'_dragging'}
          onDrop={onDrop_component_wrapper}
          DnDOverContent={DnDOverContent}
          overContentArg={{...overContentArg, minHeight: horizontalDropArea ? renderedHeight ? renderedHeight : default_grid_dropArea_height(attr) : 15,}}
          allowed_types={isDragging ? inDepth ? allowed_types_component_with_indepth : allowed_types_component : allowed_types_component_menu}
          horizontalDropArea={horizontalDropArea}
          customStyle={horizontalDropArea ? {display: 'inline-block', minWidth: 20, minHeight: renderedHeight ? renderedHeight : default_grid_dropArea_height(attr), opacity: 0.3,} : null}
        />
      )
    } 
    return (
      <RenderComponentDropArea 
        key={component_index}
        onDrop={onDrop_component_wrapper}
        DnDOverContent={DnDOverContent}
        overContentArg={{...overContentArg, minHeight: horizontalDropArea ? renderedHeight ? renderedHeight : default_grid_dropArea_height(attr) : 15,}}
        allowed_types={isDragging ? inDepth ? allowed_types_component_with_indepth : allowed_types_component : allowed_types_component_menu}
        horizontalDropArea={horizontalDropArea}
        customStyle={horizontalDropArea ? {display: 'inline-block', minWidth: 20, minHeight: renderedHeight ? renderedHeight : default_grid_dropArea_height(attr), opacity: 0.3,} : null}
      />
    )
  })()

  // const dropAreaContent = (() => {
  //   if (isDragging) {
  //     return (
  //       /* Drop area for Change component index position function */
  //       <RenderComponentDropArea 
  //         key={component_index+1}
  //         onDrop={onDrop_component_wrapper}
  //         DnDOverContent={DnDOverContent}
  //         overContentArg={{...overContentArg, minHeight: horizontalDropArea ? renderedHeight ? renderedHeight : default_grid_dropArea_height(attr) : 15,}}
  //         allowed_types={inDepth ? allowed_types_component_with_indepth : allowed_types_component}
  //         customStyle={horizontalDropArea ? {display: 'inline-block', minWidth: 20, minHeight: renderedHeight ? renderedHeight : default_grid_dropArea_height(attr), opacity: 0.3,} : null}
  //       />
  //     )
  //   }
  //   return (
  //     /* Drop area for Add component function */
  //     <RenderComponentDropArea 
  //       key={component_index}
  //       onDrop={onDrop_component_wrapper}
  //       DnDOverContent={DnDOverContent}
  //       overContentArg={{...overContentArg, minHeight: horizontalDropArea ? renderedHeight ? renderedHeight : default_grid_dropArea_height(attr) : 15,}}
  //       allowed_types={allowed_types_component_menu}
  //       horizontalDropArea={horizontalDropArea}
  //       customStyle={horizontalDropArea ? {display: 'inline-block', minWidth: 20, minHeight: renderedHeight ? renderedHeight : default_grid_dropArea_height(attr), opacity: 0.3,} : null}
  //     />
  //   )
  // })()
  
  /**
   * Grid system에 대응하는 preDropAreaContent props 활성화 시 랜더링
   */
  const preDropAreaContent = (() => {
    if (isDragging) {
      return (
        /* Drop area for Change component index position function */
        <RenderComponentDropArea 
          key={'pre'+component_index+'_dragging'}
          onDrop={(e) => {
            onDrop_component_wrapper({...e,
              preDropArea: true 
            })
          }}
          DnDOverContent={DnDOverContent}
          overContentArg={{...overContentArg, minHeight: horizontalDropArea ? renderedHeight ? renderedHeight : default_grid_dropArea_height(attr) : 15,}}
          allowed_types={allowed_types_component}
          customStyle={horizontalDropArea ? {display: 'inline-block', minWidth: 20, minHeight: renderedHeight ? renderedHeight : default_grid_dropArea_height(attr), opacity: 0.3,} : null}
        />
      )
    }
    return (
      /* Drop area for Add component function */
      <RenderComponentDropArea 
        key={'pre'+component_index}
        onDrop={(e) => {
          onDrop_component_wrapper({...e,
            preDropArea: true 
          })
        }}
        DnDOverContent={DnDOverContent}
        overContentArg={{...overContentArg, minHeight: horizontalDropArea ? renderedHeight ? renderedHeight :  default_grid_dropArea_height(attr) : 15,}}
        allowed_types={allowed_types_component_menu}
        horizontalDropArea={horizontalDropArea}
        customStyle={horizontalDropArea ? {display: 'inline-block', minWidth: 20, minHeight: renderedHeight ? renderedHeight : default_grid_dropArea_height(attr), opacity: 0.3,} : null}
      />
    )
  })()

  const renderingComponent = (attr) => {
    // console.log('renderedHeight :', renderedHeight);
    // console.log('last_saved_component_height :', last_saved_component_height);
    switch(attr) {
      /**
       * Text component
       */
      case DnD_element_type.COMPONENT.NORMAL.TEXT.inDepth:
      case DnD_element_type.COMPONENT.NORMAL.TEXT.outDepth:
        return (
          <React.Fragment>
            <div ref={depthComponentRef}>
              <DraggableComponentWrap
                messageIndex={message_index}
                rowIndex={row_index}
                rowIndexDetail={editing_row_index}
                componentIndex={component_index}
                renderedHeight={renderedHeight}
                onDragStart={onDraggedStart} 
                onDragEnd={onDraggedEnd} 
                cat_type={DnD_element_type_category.REN_ELEM}
                type={editing_row_index || editing_row_index === 0 ? DnD_element_type.COMPONENT.NORMAL.TEXT.inDepth : DnD_element_type.COMPONENT.NORMAL.TEXT.outDepth} prefix_type="NORMAL">
                <Text
                  key={local_id}
                  index={component_index}
                  id={local_id}
                  value={value}
                  menuOnShow={onShow_menu}
                  menuOnHide={onHide_menu}
                  updateComponent={_updateComponent}
                  // onOver={onOver}
                  />
              </DraggableComponentWrap>
            </div>
            {dropAreaContent}
          </React.Fragment>
        )

      /**
       * Button component
       */
      case DnD_element_type.COMPONENT.NORMAL.BUTTON.inDepth:
      case DnD_element_type.COMPONENT.NORMAL.BUTTON.outDepth:
        const render_content_button = (
          <div ref={depthComponentRef}>
              <DraggableComponentWrap
                key={local_id}
                messageIndex={message_index}
                rowIndex={row_index}
                rowIndexDetail={editing_row_index}
                componentIndex={component_index}
                renderedHeight={renderedHeight}
                handleWrapCSS={renderType === 'grid' ? {paddingLeft: 0} : undefined}
                onDragStart={onDraggedStart} 
                onDragEnd={onDraggedEnd}
                cat_type={DnD_element_type_category.REN_ELEM}
                noDrag={noDrag}
                type={editing_row_index || editing_row_index === 0 ? DnD_element_type.COMPONENT.NORMAL.BUTTON.inDepth : DnD_element_type.COMPONENT.NORMAL.BUTTON.outDepth} prefix_type="NORMAL"
              >
                <Button
                  key={local_id}
                  index={component_index}
                  id={local_id}
                  name={name}
                  value={value}
                  menuOnShow={onShow_menu}
                  menuOnHide={onHide_menu}
                  updateComponent={_updateComponent}
                  // onOver={onOver}
                />
              </DraggableComponentWrap>
          </div>
        )
        return (
          renderType === 'grid' ? (
            <GridComponentRender 
              dropArea={dropAreaContent} 
              // depthComponentRef={depthComponentRef} 
              preDropArea={preDropArea ? preDropAreaContent : undefined}>
              {render_content_button}
            </GridComponentRender>
          ) : (
            <React.Fragment>
              {render_content_button}
              { !noDropArea && (dropAreaContent)}
            </React.Fragment>
          )
        )

      /**
       * Image component
       */
      case DnD_element_type.COMPONENT.NORMAL.IMAGE.inDepth:
      case DnD_element_type.COMPONENT.NORMAL.IMAGE.outDepth:
        const render_content_image = (
          <div ref={depthComponentRef}>
            <DraggableComponentWrap
              messageIndex={message_index}
              rowIndex={row_index}
              rowIndexDetail={editing_row_index}
              componentIndex={component_index}
              renderedHeight={renderedHeight}
              handleWrapCSS={renderType === 'grid' ? {paddingLeft: 0} : undefined}
              onDragStart={onDraggedStart} 
              onDragEnd={onDraggedEnd} 
              noDrag={noDrag}
              cat_type={DnD_element_type_category.REN_ELEM}
              type={editing_row_index || editing_row_index === 0 ? DnD_element_type.COMPONENT.NORMAL.IMAGE.inDepth : DnD_element_type.COMPONENT.NORMAL.IMAGE.outDepth} prefix_type="NORMAL"
            >
              <Image
                key={index}
                index={component_index}
                id={local_id}
                name={name}
                value={value}
                resource={resource}
                menuOnShow={onShow_menu}
                menuOnHide={onHide_menu}
                updateComponent={_updateComponent}
                col={col}
                maxWidth={renderType === 'grid' || renderType === 'slide' ? true : false}
                // onOver={onOver}
              />
            </DraggableComponentWrap>
          </div>
        )
        return (
          renderType === 'grid' ? (
            <GridComponentRender 
              dropArea={dropAreaContent} 
              // depthComponentRef={depthComponentRef} 
              preDropArea={preDropArea ? preDropAreaContent : undefined}>
              {render_content_image}
            </GridComponentRender>
          ) : (
            <React.Fragment>
              {render_content_image}
              {!noDropArea && (dropAreaContent)}
            </React.Fragment>
          )
        )

      /**
       * Group component
       */
      case "GROUP":
        return (
          <React.Fragment>
            <div ref={depthComponentRef}>
              <DraggableComponentWrap
                messageIndex={message_index}
                rowIndex={row_index}
                rowIndexDetail={editing_row_index}
                componentIndex={component_index}
                renderedHeight={renderedHeight}
                onDragStart={onDraggedStart} 
                onDragEnd={onDraggedEnd} 
                cat_type={DnD_element_type_category.REN_ELEM}
                type={DnD_element_type.COMPONENT.NORMAL.GROUP} prefix_type="NORMAL"
              >
                <Group
                  key={local_id}
                  index={component_index}
                  id={local_id}
                  components={[]}
                  menuOnShow={onShow_menu}
                  menuOnHide={onHide_menu}
                  updateComponent={_updateComponent}
                  message_index={message_index}
                  row_index={row_index}
                  // onOver={onOver}
                />
              </DraggableComponentWrap>
            </div>
            {dropAreaContent}
          </React.Fragment>
        )

      // No case
      default:
        return (
          <p> Can not find any match type (if it persist, contact to admin) </p>
        )
    }
  }

  /**
   * Wrapping for implementing conditional styles
   */
  return (
    <div key={component_index} style={{pointerEvents: disable ? 'none' : 'inherit', cursor: disable ? 'not-allowed' : 'inherit'}}>
      {renderingComponent(attr)}
    </div>
  )
}

const GridComponentRender = (props) => {
  const { dropArea, preDropArea, children } = props
  const classname = classNames('component-wrap', 'grid-on',{
    'pre-grid': preDropArea
  })
  return (
    // <div>
      <div className={classname} >
      {/* <div className='component-wrap grid-on' > */}
        { preDropArea && (<PreDropAreaGrid preDropArea={preDropArea} />) }
        <div className='component-con'>
          {children}
        </div>
        <div class='drop-area-grid'>
          {dropArea}
        </div>
      </div>
    // </div>
  )
}
const PreDropAreaGrid = (props) => (
  <div>
    {props.preDropArea}
  </div>
)

const default_grid_dropArea_height = (attr) => {
  switch(attr) {
    case DnD_element_type.COMPONENT.NORMAL.BUTTON.inDepth:
    case DnD_element_type.COMPONENT.NORMAL.BUTTON.outDepth:
      return 35
    case DnD_element_type.COMPONENT.NORMAL.IMAGE.inDepth:
    case DnD_element_type.COMPONENT.NORMAL.IMAGE.outDepth:
      return 224
    default:
      return 35
  }
}

const overContentArg = {
  minHeight: 15,
  opacity: 0.3,
}

const DraggableComponentWrap = (props) => {
  return props.noDrag ? (
    props.children
  ) : (
    <DnDContext>
      <DraggableComponent dragHandle={DragHandle()} {...props}>
        {props.children}
      </DraggableComponent>
    </DnDContext>
  )
}

const mapStateToProps = (state) => ({
  // isDragging: state.DnD.isDragging,
  // slide_page_index: state.SlidePageState.slide_page_index,
})

const mapDispatchToProps = (dispatch) => ({
  // setUpdateTargetComponent: (arg) => {dispatch(setUpdateTargetComponent(arg))},
  // updateComponent: (arg) => {dispatch(updateComponent(arg))},
  // setIsDragging: (arg) => {dispatch(setIsDragging(arg))},
  // updateComponentIndexPos: (arg) => {dispatch(updateComponentIndexPos(arg))},
  // updateDepthCompIndexPos: (arg) => {dispatch(updateDepthCompIndexPos(arg))},
  // setMsgChanges: (value) => {dispatch(setMsgChanges(value))},
})

export default NormalComponentContainer